import { normalizeLineBreaks } from '../../utils/utils'
import * as S from './styles'

export default function AdditionalContent({ content, only_contacts = false }: { content: any , only_contacts: boolean}) {
    return (
        <S.Container>
            {!only_contacts && (
                <>
                    <S.Text>{normalizeLineBreaks(content.raw_text)}</S.Text>
                    {(content.links || []).map((link: any, index: number) => (
                        <S.Contact key={index}>
                            <S.ContactName>{link.label}:</S.ContactName>
                            <S.ContactInformation>
                                {link.url &&
                                    <S.ContactData
                                    href={link.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {link.url}
                                </S.ContactData>
                                }
                            </S.ContactInformation>
                        </S.Contact>
                    ))}
                </>
            )}
            {(content.contacts || []).map((contact: any, index: number) => (
                <S.Contact key={index}>
                    <S.ContactName>{contact.name}:</S.ContactName>
                    <S.ContactInformation>
                        {Object.keys(contact.phone || {}).length === 3 &&
                            <S.ContactData
                                href={`tel:+${contact.phone.international_dial_code}${contact.phone.area_code}${contact.phone.number}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                +{contact.phone.international_dial_code} ({contact.phone.area_code}) {contact.phone.number}
                            </S.ContactData>
                        }
                        {contact.phone?.commercial_number &&
                            <S.ContactData
                                href={`tel:${contact.phone.commercial_number.replace(/\D/g, '')}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {contact.phone.commercial_number}
                            </S.ContactData>
                        }
                        {contact.email &&
                            <S.ContactData
                                href={`mailto:${contact.email}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {contact.email}
                            </S.ContactData>
                        }
                        {contact.url &&
                             <S.ContactData
                             href={contact.url}
                             target="_blank"
                             rel="noopener noreferrer"
                         >
                             {contact.url}
                         </S.ContactData>
                        }
                    </S.ContactInformation>
                </S.Contact>
            ))}
        </S.Container>
    )
}